
import React, { Component, Fragment } from 'react';
import { NavLink } from "react-router-dom";
import { CURRENCY_FORMAT } from '../../../Constants/AppConstants';

class ActiveSubscriptionList extends Component {
    state = {}
    render() {
        return (<Fragment>
            <tr>
                <td data-title="Subscription ID">
                    <NavLink className="font_16  text_black fw_ar_bold let_spa_2" to={`/my-account/subscription-order-view/${this.props.subscription.subscription_id}`}>
                        <span className="subscription_order_id">{'#'}{this.props.subscription.hasOwnProperty('subscription_id') ? this.props.subscription.subscription_id : ''}</span>
                    </NavLink>
                </td>
                <td data-title="Total">
                    {this.props.subscription.hasOwnProperty('subscription_total') ? CURRENCY_FORMAT(this.props.subscription.subscription_total) : ''}
                </td>
                <td data-title="Start Date">
                    {this.props.subscription.hasOwnProperty('start_date') ? this.props.subscription.start_date : ''}
                </td>
                <td data-title="Next Payment">
                    {this.props.subscription.hasOwnProperty('next_payment') ? this.props.subscription.next_payment : ''}
                </td>
                <td data-title="Customer">{this.props.subscription.hasOwnProperty('customer') ? this.props.subscription.customer : ''}   </td>
                <td data-title="Customer"><NavLink className="font_16  text_black let_spa_2 fw_ar_reg text_underline" to={`/my-account/subscription-cancellation/${this.props.subscription.subscription_id}`}>Cancel</NavLink> </td>
            </tr>
        </Fragment>);
    }
}

export default ActiveSubscriptionList;